import * as React from 'react';
import { SearchResultItem } from '../../components/SearchResultItem';
import { TBuilders } from '../../types/redux/state';

export interface ISearchResultItemContainerProps {
  builder: TBuilders[0];
}

export function SearchResultItemContainer({ builder }: ISearchResultItemContainerProps) {
  const {
    name,
    founded,
    logoUrl = '',
    totalBuildingCount,
    totalOfferCount,
    totalBuiltCount,
    totalBuildingUrl,
    totalBuiltUrl,
    url,
    totalOffersUrl,
  } = builder;

  return (
    <SearchResultItem
      name={name}
      founded={founded}
      logoUrl={logoUrl}
      totalBuildingCount={totalBuildingCount}
      totalBuiltCount={totalBuiltCount}
      totalOffersCount={totalOfferCount}
      totalBuildingUrl={totalBuildingUrl}
      totalBuiltUrl={totalBuiltUrl}
      builderUrl={url}
      totalOffersUrl={totalOffersUrl}
    />
  );
}
